import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiProduct, ProductFormValues, QueryProductsParams } from '@core/models/api/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductsApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/products`;

  getAll(query?: QueryProductsParams): Observable<ApiProduct[]> {
    let params = new HttpParams();
    if (query?.search) {
      params = params.set('search', query.search);
    }
    if (query?.category) {
      params = params.set('category', query.category);
    }
    if (query?.status) {
      params = params.set('status', query.status);
    }
    if (query?.lowStock) {
      params = params.set('lowStock', String(query.lowStock));
    }
    return this.http.get<ApiProduct[]>(this.baseUrl, { params });
  }

  getById(id: string): Observable<ApiProduct> {
    return this.http.get<ApiProduct>(`${this.baseUrl}/${id}`);
  }

  create(payload: Partial<ProductFormValues>, image?: File[] | File | null): Observable<ApiProduct> {
    return this.http.post<ApiProduct>(this.baseUrl, this.toFormData(payload, image));
  }

  update(id: string, payload: Partial<ProductFormValues>, image?: File[] | File | null): Observable<ApiProduct> {
    return this.http.patch<ApiProduct>(`${this.baseUrl}/${id}`, this.toFormData(payload, image));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  deleteImage(id: string, imageUrl?: string, imageIndex?: number): Observable<ApiProduct> {
    let params = new HttpParams();
    if (imageUrl) {
      params = params.set('imageUrl', imageUrl);
    }
    if (imageIndex !== undefined && imageIndex !== null) {
      params = params.set('imageIndex', String(imageIndex));
    }

    return this.http.delete<ApiProduct>(`${this.baseUrl}/${id}/image`, {
      params,
      body: { imageUrl, imageIndex }
    });
  }

  private toFormData(payload: Partial<ProductFormValues>, image?: File[] | File | null): FormData {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, String(value));
      }
    });
    if (image) {
      if (Array.isArray(image)) {
        image.forEach((file) => {
          formData.append('image', file, file.name);
        });
      } else {
        formData.append('image', image, image.name);
      }
    }
    return formData;
  }
}
